import { Popover } from "bootstrap";

import { Page } from "./page.js";
import { PlaycocolaAPI } from "./playcocola_api.js";
import { RecordingManager } from "./recording_manager.js";
import { Uploader } from "./uploader.js";
import { FinalThoughts } from "./final_thoughts.js";
import { PlaytesterIdentity } from "./playtester_identity.js";
import { TimedComment } from "./timed_comment.js";
import { Utils } from "./utils.js";
import { MessageBus } from "./message_bus.js";
import { Retry } from "./retry.js";
import "./version.js";

class App {
  modal
  page
  messageBus
  uploader
  finalThoughts
  playtesterIdentity
  timedComment
  playcocolaAPI
  recordingManager

  constructor() {
  }

  async init() {
    this.initPopovers();
    this.initRecordingManager();
    this.initUploader();
    this.initFinalThoughts();
    this.initPlaytesterIdentity();
    this.initTimedComment();

    if (!this.initPlaycocolaAPI()) {
      return;
    }

    await this.loadPlaytestRound();
  }

  captureWindowErrors() {
    window.addEventListener("error", (errorEvent) => {
      MessageBus.error("Something went wrong on this page.", errorEvent);
    });

    window.addEventListener("unhandledrejection", (rejectionEvent) => {
      MessageBus.error("Something went wrong on this page.", rejectionEvent);
    });
  }

  initUploader() {
    this.uploader = new Uploader();
  }

  initPlaytesterIdentity() {
    this.playtesterIdentity = new PlaytesterIdentity();
  }

  // Returns false when the link is incomplete
  initPlaycocolaAPI() {
    const playtestRoundApiUrl = Utils.getParamValue("playtest_round_api_url");
    const apiToken = Utils.getParamValue("api_token");

    this.playcocolaAPI = new PlaycocolaAPI({
      playtestRoundApiUrl,
      apiToken
    });

    if (!playtestRoundApiUrl || !apiToken) {
      MessageBus.info("This link is incomplete. Please ask the game developer for a new one.");
      return false;
    }

    return true;
  }

  // The page is only built once the Playtest Round loaded. A connection
  // problem offers a Retry button that starts over (A17).
  async loadPlaytestRound() {
    try {
      await this.playcocolaAPI.intPlaytestRound();
    } catch (error) {
      if (Retry.isRetriable(error)) {
        console.error("loadPlaytestRound()", error);
        MessageBus.info(
          "We could not reach Playcocola. Please check your connection and click **Retry**.",
          () => { this.loadPlaytestRound(); },
          { button: "Retry" }
        );
      } else {
        MessageBus.error("We could not load this Playtest Round. The link may be wrong or out of date, please ask the game developer for a new one.", error);
      }

      return;
    }

    this.recordingManager.restoreProfile();
    this.initPage();
  }

  initPage() {
    this.page = new Page({
      playtestRound: this.playcocolaAPI.playtestRound
    });

    if (this.page.checkIfPlaytestRoundIsStillOpen()) {
      this.page.init();
      this.playtesterIdentity.check();
    }
  }

  initPopovers() {
    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
    const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new Popover(popoverTriggerEl))
  }

  initRecordingManager() {
    this.recordingManager = new RecordingManager();
  }

  initFinalThoughts() {
    this.finalThoughts = new FinalThoughts();
  }

  initTimedComment() {
    this.timedComment = new TimedComment();
  }
}

const APP = new App();
APP.captureWindowErrors();
APP.init();

window.APP = APP;

export { APP };
